<style scoped lang="sass">
.logo
  margin-bottom: 1.5rem
.page-top
  text-align: center
  background-color: var(--navigation-background-color)
  padding-top: 0 !important
  padding-bottom: 0 !important
.page-bottom
  background: linear-gradient(to bottom, var(--blue) 100px, var(--light-gray) 50.0001px)
</style>
<template>
  <div class="page">
    <div class="padded page-top">
      <img src="../assets/images/logo.svg" class="logo">
      <div v-if="$route.name === 'register'" class="font-style-1">Register or{{' '}}<router-link :to="{name: 'login'}">Login</router-link>{{' '}}to Join a Pool.</div>
      <div v-if="$route.name === 'login'" class="font-style-1"><router-link :to="{name: 'register'}">Register</router-link>{{' '}}or Login to Join a Pool.</div>
    </div>
    <div class="padded page-bottom">
      <transition name="fade-quickly" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Welcome',
  created: function() {
    this.$store.dispatch('configNavigation', {leftEnabled: false, centerEnabled: false});
  }
};
</script>
